import React, { FC } from 'react';

import { useTheme } from '../../util/theme';
import ScreenReaderText from '../ScreenreaderText';

import { getClassNames } from './Text.styles';
import { TextProps } from './Text.types';

const Text: FC<TextProps> = ({
  children,
  screenreaderText,
  size,
  fontWeight,
  italic,
  uppercase,
  color,
  backgroundColor,
  textDecoration,
  className,
  language,
  dir,
}) => {
  const theme = useTheme();
  const { text } = getClassNames({
    size,
    fontWeight,
    italic,
    uppercase,
    color,
    backgroundColor,
    textDecoration,
    theme,
    className,
  });

  if (screenreaderText != null) {
    return (
      <span className={text} lang={language} dir={dir}>
        <span aria-hidden={true}>{children}</span>
        <ScreenReaderText>{screenreaderText}</ScreenReaderText>
      </span>
    );
  }

  return (
    <span className={text} lang={language} dir={dir}>
      {children}
    </span>
  );
};

/**
 * A `Text` component simply renders a `span`. It offers size and color props so UI features don't
 * need to own this CSS. This is both a convenience for engineers and a way to enforce consistency
 * of supported text colors and `font-size`/`line-height` combinations.
 */
export default Text;
